import { format, useT } from "@/i18n";
import { HiPause, HiVolumeUp } from "react-icons/hi";
import { FeedbackBox, ReadOnlyCard } from "./ReadOnlyKit";
import { SPACING, rs } from "./readOnlyStyles";
import type { ReadOnlyTemplateProps } from "./types";
import { useReviewAudio } from "./useReviewAudio";

const playCard = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: SPACING.lg,
  backgroundColor: "#FBFAFF",
  borderRadius: 20,
  padding: `${SPACING.lg}px ${SPACING.md}px`,
  border: "none",
  width: "100%",
  cursor: "pointer",
} as const;

/** A past phonics-decode play: the sound the student was asked to say, and their attempt. */
export function SpellingToSoundReadOnly({
  snapshot,
  response,
  score,
  recordingUrl,
}: ReadOnlyTemplateProps<"spellingToSound">) {
  const t = useT();
  const { phoneme } = snapshot.slideData;
  const { playingUrl, toggle } = useReviewAudio();

  const myRecording = recordingUrl(response.take.recordingId);
  const isPlaying = playingUrl === myRecording;
  const Glyph = isPlaying ? HiPause : HiVolumeUp;

  return (
    <ReadOnlyCard title={snapshot.name} score={score}>
      {/* The recording is the whole answer here — the student always says the prompt, so the sound
          they were given doubles as the play control for how they said it. */}
      <button
        type="button"
        disabled={!myRecording}
        onClick={() => toggle(myRecording)}
        aria-label={
          myRecording
            ? format(
                isPlaying ? t["readonly.stopMySoundRecording"] : t["readonly.playMySoundRecording"],
                { phoneme: phoneme ?? t["readonly.theSound"] }
              )
            : t["readonly.myRecordingUnavailable"]
        }
        style={{ ...playCard, ...(!myRecording && rs.speakerDisabled) }}
      >
        <span style={rs.heroPhoneme}>{phoneme ?? "—"}</span>
        <Glyph size={28} color="#F4872A" />
      </button>

      {response.explanation ? <FeedbackBox text={response.explanation} /> : null}
    </ReadOnlyCard>
  );
}
